import { ReactComponent as MousePointerSolid } from '../../assets/svg/mouse-pointer-solid.svg';

export default MousePointerSolid;
